import React, { useRef } from 'react';

// Utils
import { useMediaQuery } from 'react-responsive';

// Components
import * as S from './Styled';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '../Button';
import useOnClickOutside from '../../hooks/useOnClickOutside';

// Store
import { useDispatch } from 'react-redux';
import { TheBehaviorDrawer } from '../../actions';

const defaultProps = {
  placement: 'left',
};

const CityPopover = ({
  onChangeCity,
  location,
  confirmLocation,
  placement,
  _popover,
}) => {
  const [visible, setVisible] = _popover;
  const dispatch = useDispatch();
  const isMob = useMediaQuery({ query: '(max-width: 767px)' });
  const { t } = useTranslation();
  const cityRef = useRef(null);

  const onConfirm = () => {
    confirmLocation();
    setVisible(false);
    dispatch(TheBehaviorDrawer(false));
  };

  const onClose = () => {
    if (!isMob) {
      setVisible(false);
    }
  };

  useOnClickOutside(cityRef, onClose);

  return visible ? (
    <S.CityPopover placement={placement} ref={cityRef}>
      <S.Triangle placement={placement} />
      <S.InnerContent>
        {isMob ? (
          <S.LocImage>
            <img
              src="/assets/svg/icons/location_stroked_gray.svg"
              alt={t('labels.location')}
            />
          </S.LocImage>
        ) : null}
        <S.Header>
          {t('labels.your_city')} – {location?.name ?? t('labels.not_defined')}
        </S.Header>
        <S.Text>
          <Trans i18nKey="labels.you_are_shown_products_with_delivery_in_this_city">
            You are shown products with delivery
            <br /> in this city
          </Trans>
        </S.Text>
        <S.Footer>
          <Button
            size="small"
            type="primary"
            htmlType="button"
            onClick={onConfirm}
          >
            {t('buttons.yes_right')}
          </Button>
          <Button
            type="secondary"
            size="small"
            onClick={event => {
              onChangeCity(event);
            }}
            htmlType="button"
          >
            {t('buttons.to_change_the_city')}
          </Button>
        </S.Footer>
      </S.InnerContent>
    </S.CityPopover>
  ) : null;
};

CityPopover.defaultProps = defaultProps;

export default CityPopover;
